import React, { Fragment } from 'react';
import { ErrorBox, Tooltip, Button, WarningIcon } from '../styles';

export const WarningIconWithPopup = ({
  title = 'Error',
  text = 'This answer doesn’t make sense.',
  handlePressChange = () => { /* noop */ },
  handlePressDismiss = () => { /* noop */ },
  className = ''
}) => (<Tooltip className={className} id="box-report" title={
  <Fragment>
    <p className="title">{title}</p>
    <p>{text}</p>
    <Button onClick={handlePressChange} variant="outlined">Change Entry</Button>
    <Button onClick={handlePressDismiss} variant="outlined">is OK</Button>
  </Fragment>
  } interactive>
  <ErrorBox isWarning><div className="circle"/><WarningIcon /></ErrorBox>
</Tooltip>);
